export const moduleConfig = {
    entityKey: 'invoices',
    titles: {
        singular: 'Invoice',
        plural: 'Invoices'
    }
}

export const initialSortState = {
    column: 'created',
    direction: 'desc',
};